import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=df9636d6&scoped=true&"
import script from "./InputDate.vue?vue&type=script&lang=ts&"
export * from "./InputDate.vue?vue&type=script&lang=ts&"
import style0 from "./InputDate.vue?vue&type=style&index=0&id=df9636d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9636d6",
  null
  
)

export default component.exports